import React, { Component } from "react";
import Header from "../layout/Header";
import Image from "../../images/Picture10.jpeg";

export class PrincipalVSDC extends Component {
  render() {
    return (
      <div className="site-main">
        <Header />
        {/* page-title */}
        <div className="ttm-page-title-row principalbanner">
          <div className="container-xl">
            <div className="row">
              <div className="col-md-12">
                <div className="title-box text-center">
                  <div className="page-title-heading card_box">
                    <h4 className="title" style={{ color: "white" }}>
                      Principal
                    </h4>
                    <div className="ttm-color-home">
                      <span className="ttm-color-home">
                        <a
                          title="Homepage"
                          href={process.env.PUBLIC_URL + "/"}
                          className="ttm-color-home"
                        >
                          <i className="ti ti-home" />
                          &nbsp;&nbsp;Home
                        </a>
                      </span>
                      <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                      <span className="ttm-color-home">VSDCH</span>
                    </div>
                  </div>
                  {/* /.page-title-captions */}
                </div>
              </div>
              {/* /.col-md-12 */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container */}
        </div>
        {/* page-title end*/}
        {/* Principal-section */}
        <section className="ttm-row aboutus-section clearfix">
          <div className="container-xl">
            <div className="row">
              {/* row */}
              <div className="col-lg-6">
                {/* section title */}
                <div
                  className="section-title with-desc clearfix"
                  style={{ paddingBlockEnd: "40px" }}
                >
                  <div className="title-header">
                    <h2 className="title">Principal</h2>
                  </div>

                  <div className="title-desc-ff text-justify">
                    <h5>Dr. Santosh Ramegowda </h5>
                    <p>
                      <strong>
                        Principal, Vokkaligara Sangha Dental College & Hospital
                      </strong>
                    </p>
                    <p>Dear Students, Faculty, and Parents,</p>
                    <p>
                      It is with a profound sense of responsibility and pride
                      that I welcome you to Vokkaligara Sangha Dental College &
                      Hospital.
                    </p>
                    <p>
                      We stand at a unique intersection where tradition meets
                      innovation. At V.S. Dental College, our aim is not merely
                      to award degrees but to train our students to cross the
                      threshold into a globally competitive world with
                      competence, character, and confidence. We believe that an
                      educational institution is a “world in miniature,” where
                      one receives training for life—learning to face
                      challenges, accept setbacks, and rejoice in victory with
                      humility.
                    </p>
                    <p>
                      Our curriculum is designed to be progressive. We are
                      committed to providing an ecosystem that fosters academic
                      excellence through state-of-the-art infrastructure,
                      advanced technological equipment, and a dedicated faculty
                      who are stalwarts in their respective fields. Whether it
                      is keeping pace with the latest advancements in digital
                      dentistry or engaging in groundbreaking research, we
                      ensure our students are exposed to international standards
                      right here on campus.
                    </p>
                    <p>
                      However, the heart of our profession remains service.
                      Consistent with the ethos of the Vokkaligara Sangha, we
                      emphasize the importance of serving the community. Our
                      vast patient flow in the OPD ensures that our students
                      receive unparalleled clinical exposure, allowing them to
                      hone their skills while providing high-quality healthcare
                      to all sections of society.
                    </p>
                    <p>
                      To my students: I assure you that the management and
                      faculty are here to nurture your growth at every step. We
                      are dedicated to helping you acquire the skills,
                      knowledge, and ethical grounding required to succeed not
                      just as clinicians, but as leaders in the field of
                      dentistry.
                    </p>
                    <p>
                      I am confident that you will address yourself to the tasks
                      of learning with deep involvement and come out with flying
                      colors, carrying the legacy of this esteemed institution
                      forward.
                    </p>
                    <p>
                      <strong>Dr. Santosh Ramegowda</strong>
                      <br />
                      Principal
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="position-relative res-991-mt-30">
                  {/* ttm_single_image-wrapper */}
                  <div className="ttm_single_image-wrapper text-sm-center">
                    <div className="featured-imagebox featured-imagebox-portfolio ">
                      <div className="featured-thumbnail">
                        <img
                          className="img-fluid"
                          src={Image}
                          title="single-img-seven"
                          alt="single-img-seven"
                        />
                      </div>
                      {/* ttm_single_image-wrapper end */}
                      <div>
                        <div>
                          <br />
                        </div>
                        <div>
                          <div
                            className="member-info-box border"
                            style={{ padding: "10px", textAlign: "left" }}
                          >
                            <div className="timing-box">
                              <h4>Dr. Santosh Ramegowda</h4>
                            </div>
                            <ul className="info-list">
                              <li>Principal ,</li>
                              <li>
                                <i className="ti ti-location-pin" />
                                <span>
                                  {" "}
                                  V S Dental College & Hospital Bengaluru.
                                </span>
                              </li>
                              <li>
                                <i className="ti ti-mobile" />
                                <span>
                                  {" "}
                                  Phone: 9845428008 Email: santu819@gmail.com
                                </span>
                              </li>

                              <li>
                                <i className="ti ti-comment" />
                                <span>
                                  College Email: vsdchbangalore@gmail.com
                                </span>
                              </li>
                              <li>
                                <span>Achievements And Designation</span>
                              </li>
                              <li>
                                • Editor, Indian Orthodontic Newsletter
                                (2022-2024)
                              </li>
                              <li>
                                • Chairman, Board of Studies, Gujarat University
                                (2020 - 2025)
                              </li>
                              <li>
                                • Joint Organizing Secretary, 10th Indian
                                Orthodontic Society PG Convention, Bangalore
                                (2007)
                              </li>
                              <li>
                                • Orthodontic Public Awareness Programme -
                                Karnataka Smile Torch Bearer (2015)
                              </li>
                              <li>
                                • Scientific Chairman, 5th Indian Lingual
                                Orthodontic Conference (2016)
                              </li>
                              <li>
                                • Elected Executive Committee Member, Indian
                                Orthodontic Society (2015-2024)
                              </li>
                              <li>
                                • Convenor, Bangalore Orthodontic Study Group
                                (2010 - 2025)
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* row end */}
          </div>
        </section>
        {/* Principal-section end*/}
      </div>
    );
  }
}

export default PrincipalVSDC;
